import React, { useState, useEffect, useContext } from "react";
// import { useCallback } from "react";

const url = "https://www.thecocktaildb.com/api/json/v1/1/search.php?s=";
const AppContext = React.createContext();

const getLocalCocktails = () => {
  let cocktails = localStorage.getItem("cocktails");
  if (cocktails) {
    return (cocktails = JSON.parse(localStorage.getItem("cocktails")));
  } else {
    return [];
  }
};

const AppProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("a");
  const [cocktails, setCocktails] = useState(getLocalCocktails() || []);
  const [tempCocktails, setTempCocktails] = useState(cocktails);

  const fetchDrinks = async () => {
    setLoading(true);
    if (cocktails.length !== 0) {
      console.log(cocktails);
      setLoading(false);
    } else {
      try {
        const response = await fetch(`${url}${searchTerm}`);
        const data = await response.json();
        const { drinks } = data;
        if (drinks) {
          const newCocktails = drinks.map((item) => {
            const {
              idDrink,
              strDrink,
              strDrinkThumb,
              strAlcoholic,
              strGlass,
              strInstructions,
              strIngredient1,
              strIngredient2,
              strIngredient3,
              strIngredient4,
              strIngredient5,
            } = item;
            return {
              id: idDrink,
              name: strDrink,
              image: strDrinkThumb,
              info: strAlcoholic,
              glass: strGlass,
              instructions: strInstructions,
              ingredient1: strIngredient1,
              ingredient2: strIngredient2,
              ingredient3: strIngredient3,
              ingredient4: strIngredient4,
              ingredient5: strIngredient5,
              favorite: false,
            };
          });
          localStorage.setItem("cocktails", JSON.stringify(newCocktails));
          setCocktails(newCocktails);
          setTempCocktails(newCocktails);
        } else {
          setCocktails([]);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  const searchDrink = () => {
    const newCocktails = cocktails.filter((item) => {
      if (item.name.toLowerCase().includes(searchTerm.toLocaleLowerCase())) {
        return item;
      }
    });
    setTempCocktails(newCocktails);
  };

  useEffect(() => {
    fetchDrinks();
  }, []);

  useEffect(() => {
    searchDrink();
  }, [searchTerm]);

  return (
    <AppContext.Provider
      value={{
        loading,
        cocktails,
        setCocktails,
        tempCocktails,
        setTempCocktails,
        setSearchTerm,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// make sure use
export const useGlobalContext = () => {
  return useContext(AppContext);
};

export { AppContext, AppProvider };
